import { motion } from "framer-motion";
import { Home, MapPin, ShieldCheck, Zap } from "lucide-react";
import { Reveal, stagger, item } from "@/components/motion/Reveal";

const reasons = [
  { n: "01", icon: Home, title: "Trusted family-run business", desc: "You're dealing with real, local people who care — not an impersonal corporation. Our name is on every job." },
  { n: "02", icon: MapPin, title: "Serving Charlotte & surrounding areas", desc: "Proudly local. We know the homes and neighborhoods we serve, and we show up when we say we will." },
  { n: "03", icon: ShieldCheck, title: "Careful attention to detail & quality", desc: "From the smallest repair to the final wipe-down, we treat your home with respect and precision." },
  { n: "04", icon: Zap, title: "Fast, no-obligation quotes", desc: "Message us on WhatsApp and get a clear, honest quote quickly — no pressure, no surprises." },
];

export default function WhyChooseUs() {
  return (
    <section id="why" className="relative py-20 md:py-32 bg-petrol text-offwhite overflow-hidden" data-testid="why-section">
      <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-mustard/10 blur-3xl" />
      <div className="max-w-7xl mx-auto px-5 lg:px-12 relative">
        <Reveal className="max-w-2xl mb-14 md:mb-20">
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-mustard mb-4">Why C Duarte Home Pro</p>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-tight">
            Serious, careful, local people.
          </h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="grid sm:grid-cols-2 gap-x-10 gap-y-4"
        >
          {reasons.map((r) => (
            <motion.div
              key={r.n}
              variants={item}
              className="group flex gap-6 py-8 border-t border-offwhite/15"
              data-testid={`reason-${r.n}`}
            >
              <span className="font-display font-extrabold text-4xl md:text-5xl text-offwhite/20 group-hover:text-mustard transition-colors duration-500 leading-none">
                {r.n}
              </span>
              <div>
                <div className="flex items-center gap-3 mb-3">
                  <r.icon className="h-5 w-5 text-mustard" strokeWidth={2} />
                  <h3 className="font-display font-bold text-lg md:text-xl">{r.title}</h3>
                </div>
                <p className="text-offwhite/70 font-light leading-relaxed max-w-md">{r.desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
